import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const largeTitleClassNames = {
  root: 'fui-LargeTitle'
};
/**
 * Styles for the root slot
 */
export const useLargeTitleStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f15afnhw",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fr3w3wp"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f15afnhw{font-size:var(--fontSizeHero900);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fr3w3wp{line-height:var(--lineHeightHero900);}"]
});